/* unplugin-vue-components disabled */import { render } from "./rizhi_new.vue?vue&type=template&id=6fd61192&scoped=true"
import script from "./rizhi_new.vue?vue&type=script&lang=js"
export * from "./rizhi_new.vue?vue&type=script&lang=js"

import "./rizhi_new.vue?vue&type=style&index=0&id=6fd61192&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd61192"]])

export default __exports__